import { getPubSub, PubSub, ClientsideLogger, Logger } from '@utils'
import { InputAction, HandlerDownloadStatus, HandlerHandshake, HandlerDownloadsAll, InputActions, InputHandlers, HandlerGetAppSettings } from './inputActions'
import { OutputAction } from './outputActions'

export type SubscribeReturn = (() => void) | void

export class UWPNotifier {
    private myWindow: any
    public logger: any
    private static instance: UWPNotifier
    private pubSub: PubSub

    private constructor(otherwindow: any, logger: Logger = new ClientsideLogger('DVWebNodeSPA/UWPNotifier')) {
        this.myWindow = otherwindow
        this.logger = logger
        this.pubSub = getPubSub()
        this.init()
    }

    public static getInstance() {
        if (!this.instance) {
            this.instance = new UWPNotifier(window)
        }
        return this.instance
    }

    subscribe(a: InputAction.Download_Status, h: HandlerDownloadStatus): SubscribeReturn
    subscribe(a: InputAction.Handshake, h: HandlerHandshake): SubscribeReturn
    subscribe(a: InputAction.Downloads_All, h: HandlerDownloadsAll): SubscribeReturn
    subscribe(a: InputAction.AppSettings, h: HandlerGetAppSettings): SubscribeReturn
    subscribe(action: InputActions, handler: InputHandlers): SubscribeReturn {
        try {
            return this.pubSub.subscribe(action.toString(), handler)
        } catch (err) {
            const errorMessage = 'UWPNotifier failed to subscribe to an event from the native app'
            this.logger.error(errorMessage, action, handler, err)
        }
    }

    unsubscribe(action: InputAction, handler: InputHandlers) {
        try {
            return this.pubSub.unsubscribe(action.toString(), handler)
        } catch (err) {
            const errorMessage = 'UWPNotifier failed to unsubscribe to an event from the native app'
            this.logger.error(errorMessage, action, handler, err)
            return Promise.reject(new Error(errorMessage))
        }
    }

    publish(action: OutputAction, payload?: any) {
        const timestamp = Date.now();
        try {
            this.notify(JSON.stringify({ action, payload, timestamp }))
        } catch (err) {
            this.logger.error('UWPNotifier failed to generate the payload and notify the native app', action, payload, timestamp, err)
        }
    }

    private init() {
        this.myWindow.primevideoUWPNotifierHandler = this.inputDispatcher.bind(this)
    }

    // IMPORTANT: DO NOT CHANGE THIS METHOD
    // Notify needs to be called from within the `external` object, see https://quip-amazon.com/rsCqAIFSpbCz
    private notify(str: string) {
        if (global.__SERVER__ && !global.__DEVSERVER__) {
            this.logger.error('UWPNotifier needs to be executed on the client', str)
        } else {
            try {
                this.myWindow.external.notify(str)
            } catch (err) {
                this.logger.error('UWPNotifier failed to notify the native app', str, err)
            }
        }
    }

    private inputDispatcher(action: string, payload: string) {
        try {
            const parsedPayload = JSON.parse(payload)
            this.pubSub.publish(action, parsedPayload)
        } catch (err) {
            this.logger.error('UWPNotifier failed to parse the native action payload', action, payload, err)
        }
    }
}
